namespace TabAurous.Production {
    export namespace JobCardSummaryService {
        export const baseUrl = 'Production/JobCardSummary';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/JobCardSummary/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JobCardSummaryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
